import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    SheetContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const SheetContext = createContext<SheetContextType | undefined>(undefined);

export const useSheetContext = ({
    part
}: {
    part: string;
}) => {
    const context = useContext(SheetContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `Sheet.${part} must be rendered inside Sheet.`
        });
    }, [
        context
    ]);

    return context;
};
